import React from 'react';

const ServiceTermsPage: React.FC = () => {
  return (
    <div className="legal-page container py-5">
      <h1 className="mb-4">服务声明 / 用户协议</h1>

      <p className="text-muted mb-4">
        本协议是用户（以下简称“您”）与 GitHub AI 平台之间关于使用本网站及相关服务所订立的法律协议。
        使用或继续使用本网站，即表示您已阅读、理解并同意接受本协议的全部内容。
      </p>

      <h3>一、平台简介</h3>
      <p>
        GitHub AI 是一个面向开发者的 GitHub 项目搜索与分析平台，通过整合 GitHub Trending、GitHub API
        及第三方大模型服务，为您提供项目检索、趋势分析、收藏管理、AI 辅助解读等功能。本平台与 GitHub 官方及相关开源项目作者并无隶属或合作关系。
      </p>

      <h3>二、账户注册与使用</h3>
      <ul>
        <li>您需根据页面提示提供手机号码、用户名、密码等信息完成注册，并保证信息真实、准确、完整。</li>
        <li>账户仅限本人使用，您应妥善保管登录凭证，不得转让、出租或出借给他人使用。</li>
        <li>如发现账号被未经授权使用或存在安全风险，请及时通过页面提供的联系方式与我们取得联系。</li>
      </ul>

      <h3>三、服务内容与使用规范</h3>
      <ul>
        <li>平台提供的搜索结果、Trending 数据及项目信息均来自第三方公开数据，仅供参考。</li>
        <li>
          您在使用平台过程中，不得从事任何违反法律法规、侵犯他人合法权益或破坏平台安全与稳定的行为，包括但不限于：
          <ul>
            <li>利用平台实施或协助实施任何违法犯罪活动；</li>
            <li>对 GitHub 或第三方服务进行恶意抓取、攻击、批量滥用；</li>
            <li>以任何方式绕过平台访问控制、频率限制、付费限制等安全措施；</li>
            <li>未经许可，将平台提供的服务或数据对外有偿提供或转售。</li>
          </ul>
        </li>
        <li>如您违反本条款，我们有权视情节采取限制功能、冻结或注销账号等措施，并保留追究法律责任的权利。</li>
      </ul>

      <h3>四、数据与知识产权</h3>
      <ul>
        <li>平台界面、功能设计、文案内容、AI 生成的解读结果等，由本平台或相关权利人依法享有知识产权。</li>
        <li>GitHub 项目本身的代码、文档及相关内容，其知识产权归各开源项目及其作者所有。</li>
        <li>
          您在平台提交的反馈、评论等内容，授权平台在合理范围内用于展示、运营及服务改进，但不会在未经您同意的情况下向无关第三方出售。
        </li>
      </ul>

      <h3>五、第三方服务说明</h3>
      <p>
        本平台部分功能依赖第三方服务（包括但不限于 GitHub API、LLM 模型服务等）。这些服务的可用性、稳定性和变更由相应服务提供方决定，
        可能导致本平台部分功能暂时或永久不可用。对此类情形，我们不承担由第三方服务本身引起的责任，但会尽合理努力进行协调和优化。
      </p>

      <h3>六、免责声明与责任限制</h3>
      <ul>
        <li>平台提供的搜索结果、统计信息和 AI 解读仅供参考，不构成任何投资建议、技术保证或法律意见。</li>
        <li>我们不保证所有信息完全准确、完整、实时，也不保证服务不间断或无错误。</li>
        <li>
          在法律允许的最大范围内，对于因使用或无法使用本平台服务所导致的任何直接或间接损失（包括但不限于数据丢失、业务中断、
          盈利损失等），平台的责任总额以您因使用付费服务向平台实际支付的费用为上限；如您仅使用免费服务，则平台在法律允许范围内不承担赔偿责任。
        </li>
      </ul>

      <h3>七、服务变更、中断与终止</h3>
      <ul>
        <li>我们有权根据业务发展需要，对服务内容进行调整、升级、下线或变更计费模式。</li>
        <li>如因重大调整或业务终止，我们将尽可能提前在网站显著位置公告，并说明相关安排。</li>
        <li>因法律法规要求、监管要求或不可抗力导致服务中断或终止的，我们将尽合理努力减少对您的影响。</li>
      </ul>

      <h3>八、适用法律与争议解决</h3>
      <p>
        本协议的订立、生效、履行与争议解决，适用中华人民共和国法律（不含港澳台地区法律）。
        如因本协议产生任何争议，双方应首先友好协商解决；协商不成时，可向平台运营方所在地有管辖权的人民法院提起诉讼。
      </p>

      <h3>九、联系我们</h3>
      <p>
        如您对本服务声明 / 用户协议有任何疑问、建议或投诉，可通过网站页脚展示的联系方式与我们取得联系，我们会尽快处理。
      </p>
    </div>
  );
};

export default ServiceTermsPage;

